import React from 'react';
import { WrappedCard } from '../WrappedCard';
import { wrappedCopy } from '../../../lib/wrapped/wrappedCopy';
import { format } from 'date-fns';

interface HighestSessionCardProps {
  highestSession: {
    date: Date;
    wingo: number;
    sourceType?: string | null;
  } | null;
  avatarUrl?: string;
  username?: string;
}

export const HighestSessionCard: React.FC<HighestSessionCardProps> = ({
  highestSession,
  avatarUrl,
  username,
}) => {
  if (!highestSession) {
    return (
      <WrappedCard>
        <p className="text-lg text-yellow-300">No sessions found</p>
      </WrappedCard>
    );
  }

  return (
    <WrappedCard className="relative" username={username}>
      <div className="space-y-4 md:space-y-6 relative z-10">
        {/* User avatar */}
        {avatarUrl && (
          <div className="flex justify-center mb-4 md:mb-6">
            <img
              src={avatarUrl}
              alt="User avatar"
              className="w-32 h-32 md:w-40 md:h-40 rounded-full object-cover border-4 border-yellow-400 shadow-2xl"
              style={{ objectPosition: 'center top' }}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = '/avatars/default.png';
              }}
            />
          </div>
        )}
        
        <p className="text-xl md:text-2xl lg:text-3xl text-yellow-200 font-bold mb-4 md:mb-6 drop-shadow-lg px-2">
          {wrappedCopy.cards.highestSession.title}
        </p>
        <div className="bg-black/60 backdrop-blur-md rounded-2xl p-5 md:p-6 border-2 border-yellow-400/50 shadow-2xl mb-3 md:mb-4">
          <div className="text-7xl md:text-8xl lg:text-9xl font-bold bg-gradient-to-r from-yellow-300 via-yellow-200 to-amber-200 bg-clip-text text-transparent mb-2 md:mb-3 break-words">
            {highestSession.wingo.toLocaleString()}
          </div>
          <p className="text-sm md:text-base lg:text-lg text-yellow-300 font-medium">
            {format(highestSession.date, 'MMMM d, yyyy')}
          </p>
        </div>
      </div>
    </WrappedCard>
  );
};

